import { Injectable } from '@angular/core';
import {AuthenticationService} from './authentication.service'
import {SpinnerService} from './shared/spinner.service'
import { interval, Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  constructor(private auth:AuthenticationService , private tspinner:SpinnerService) { }

    intervalId: any;
    sp:any=false
    private subscription!: Subscription;
    network(){
    if(!navigator.onLine  && this.auth.uiHost!='localhost' ){
      this.sp=true
      this.tspinner.show('Opps !! Network Issue','Check the internet')
    } 
    
    if(navigator.onLine  && this.sp){
      this.tspinner.hide()
      if (this.subscription) {
        this.subscription.unsubscribe();
        }
      this.sp=false
    } 
  
    if(!navigator.onLine ){
      this.check()
    }
    }
  
  
    check(){
    this.subscription = interval(1000) // 15 seconds in milliseconds
    .subscribe(() => {
      if (this.subscription) {
        this.subscription.unsubscribe();
        }
      this.network();
    });
    }



}
